import { createFileRoute } from '@tanstack/react-router';

import {
  loadTenantPermissionResourceMessages,
  loadTenantPermissionResourceScreens,
  tenantPermissionResourceFormScreen,
  tenantPermissionResourceFormSearch,
} from '@/modules/tenant-permission-resource/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Cadastro de recursos (`router.tsx:2041-2048`); `novo` cria. Arquivo leve (JS inicial).
export const Route = createFileRoute('/_app/seguranca/recursos-correspondente/$id/')({
  validateSearch: tenantPermissionResourceFormSearch,
  staticData: { screen: tenantPermissionResourceFormScreen },
  loader: () => loadTenantPermissionResourceMessages(),
  component: lazyScreen(loadTenantPermissionResourceScreens, 'TenantPermissionResourceFormPage'),
});
